import _ from 'underscore';

import {Optional} from './Types';

interface SortParams {
  key?: Optional<string>;
  limit?: Optional<number>;
  offset?: Optional<number>;
  reverse?: unknown;
  summary?: Optional<string | number>;
}

export interface FetchParams {
  sort?: Optional<SortParams | string>;
  [key: string]: unknown;
}
export interface SanitizedFetchParams {
  sort?: string;
  limit?: number;
  offset?: number;
  reverse?: '1';
  summary?: string | number;
}

/**
 * Sanitizes params for GET endpoints
 * @param {object} fetchParams Raw fetch params
 * @param {...string} paramNames Param name whitelist
 */
function sanitizeFetchParams(
  fetchParams: FetchParams = {},
  ...paramNames: Array<string>
): SanitizedFetchParams {
  const sanitizedParams = _.chain(fetchParams)
    .pick(...paramNames)
    .omit((param: {}) => param == null)
    .value() as unknown as FetchParams;
  const {sort} = sanitizedParams;
  // Several keys are commonly bundled under 'sort' so properly unpack them here
  if (sort && _.isObject(sort) && typeof sort !== 'string') {
    if (sort.limit != null && sort.limit !== 0) {
      sanitizedParams.limit = sort.limit;
    }
    if (sort.offset != null && sort.offset !== 0) {
      sanitizedParams.offset = sort.offset;
    }
    if (sort.reverse) {
      sanitizedParams.reverse = '1';
    }
    if (sort.key != null) {
      sanitizedParams.sort = sort.key;
    } else {
      delete sanitizedParams.sort;
    }
  }

  // TypeScript is confused about the `sort` field, so we need to tell it the type
  if ('sort' in sanitizedParams) {
    return sanitizedParams as {sort: string};
  } else {
    return sanitizedParams as {sort: never};
  }
}

export default sanitizeFetchParams;
